import React from 'react';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import QuestionIcon from '../../assets/icons/questionSmall.svg';
import useComponentVisible from '../../hooks/useComponentVisible';

export const QUESTION_HINT_POSITIONS = {
  right: 'right',
  bottomLeft: 'bottomLeft',
  bottomRight: 'bottomRight',
};

function QuestionHint({ text, position = QUESTION_HINT_POSITIONS.right }) {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible();

  return (
    <div className={styles.wrapper} ref={ref}>
      <div
        className={classNames(styles.button, 'pressable')}
        onClick={() => setIsComponentVisible((prev) => !prev)}
      >
        <img src={QuestionIcon} alt="?" />
      </div>
      <div
        className={classNames(
          styles.hint,
          styles[`hint_${position}`],
          { [styles.hintVisible]: isComponentVisible },
        )}
      >
        <p className={styles.hintText}>{text}</p>
      </div>
    </div>
  );
}

export default QuestionHint;
